import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useAxiosInstance } from '@/api/util/useAxiosInstance.util.tsx';
import CONFIG from '@/config/config.ts';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QueryKeyEnum } from '../api/model/QueryKey.enum.ts';

interface InternalModeResponse {
  internalModeEnabled: boolean;
}

type Response = boolean;

interface Return {
  internalMode: Response;
  isLoading: boolean;
}

export const useCheckInternalMode = (): Return => {
  const { restAuthenticationApi } = useApiClient();
  const axiosInstance = useAxiosInstance();

  const { data, isLoading } = useQuery<Response, AxiosError>({
    queryFn: async () => {
      try {
        // Sprawdzam czy metoda istnieje w wygenerowanym API
        // @ts-ignore
        if (typeof restAuthenticationApi.checkInternalMode === 'function') {
          // @ts-ignore
          const response = await restAuthenticationApi.checkInternalMode();
          console.log('[useCheckInternalMode] Response from generated API:', response?.data);
          return response?.data?.internalModeEnabled ?? false;
        }
        
        // Jeśli metoda nie istnieje, użyj bezpośredniego wywołania z useAxiosInstance
        const response = await axiosInstance.get<InternalModeResponse>(
          `${CONFIG.HOST}/api/internal-mode`
        );
        console.log('[useCheckInternalMode] Response from axios:', response.data);
        return response.data?.internalModeEnabled ?? false;
      } catch (error) {
        // Obsługa błędów (401, 404, etc.) - zwracamy false
        console.warn('[useCheckInternalMode] Request failed:', error);
        return false;
      }
    },
    queryKey: [QueryKeyEnum.CHECK_INTERNAL_MODE],
    retry: false,
    staleTime: Infinity,
  });

  console.log('[useCheckInternalMode] Hook returning:', { internalMode: data ?? false, isLoading });
  return { internalMode: data ?? false, isLoading };
};
